import React, { ReactElement } from "react";

import { ContentVersionSourceBadge } from "../components/ContentVersionSourceBadge";
import { ContentVersionSource } from "../types/ContentVersionSource";

export const renderContentVersionSource = <T extends { source: ContentVersionSource }>(
    item?: T
): ReactElement | null => {
    if (!item?.source) return null;

    return <ContentVersionSourceBadge value={item.source} />;
};
